export default __webpack_public_path__ + "static/media/progress.c61e60e2.svg";